<template>
  <integrations-template
    :loading="page.data.loading"
    :data="page.data.items"
    :shipping-accounts="data.shippingAccounts"
    :service-name-mapping="nameMapping"
    :allowed-ftp-carriers="data.allowedFtpCarriers"
    @create="page.create"
    @update="page.update"
    @delete="page.remove">
    <template #message>
      <alert
        v-if="page.data.message"
        :type="page.data.messageStatus"
        :close="true"
        @close="page.data.message = ''">
        {{ page.data.message }}
      </alert>
    </template>
  </integrations-template>
</template>

<script>
export default {
  name: 'Integrations',
};
</script>

<script setup>
import { reactive, onMounted, } from 'vue';

import Alert from '../../atoms/Alert';
import IntegrationsTemplate from '../../templates/Integrations';

import { showFailMessage, withLoading } from "../../../utils";
import usePage from '../../../mixins/usePage';
import client from "../../../api";
import { IntegrationService, ShippingAccountService } from '../../../services';

const nameMapping = {
  1: 'Salesforce Core',
  2: 'Salesforce Commerce Cloud',
  8: 'Newstore',
  9: 'FTP',
  10: 'UPS Quantum View',
};

const formatItemName = value => value.name || nameMapping[value.service];
const page = usePage(IntegrationService, formatItemName);

const data = reactive({
  shippingAccounts: [],
  allowedFtpCarriers: [],
});

onMounted(async () => {
  await withLoading(page, async () => {
    await page.read();

    try {
      data.shippingAccounts = await ShippingAccountService.get();
    } catch {
      await showFailMessage(page, "Shipping Account list wasn't loaded!");
      return;
    }

    try {
      data.allowedFtpCarriers = await client.getSftpCarriers();
    } catch {
      await showFailMessage(page, "Carrier list wasn't loaded!");
    }
  });
});
</script>
